<template>
  <div>

    <a v-if="url" target="_blank" :href="url"
       :class="classObject">
      {{ description }}
    </a>
    <span v-else
          :class="classObject">
      {{ description }}
    </span>
  </div>
</template>

<script>
/*
public const Unscheduled = 0;
public const YetToStart = 10;
public const Imminent = 15;
public const InProgress = 20;
public const Finished = 30;
public const Unknown = 99;
*/

const UNSCHEDULED = 0;
const YET_TO_START = 10;
const IMMINENT = 15;
const IN_PROGRESS = 20;
const FINISHED = 30;
const UNKNOWN = 99;


export default {
  name: "MeetupStatus",
  computed: {

    human() {

      if (this.countdown === '') {
        return '';
      }

      let day = '';

      if (this.seconds < 0) {
        if (this.seconds > -60) {
          return Math.abs(this.seconds) + ' seconds ago';
        }
        if (this.seconds > -120) {
          return this.min + ' minute ' + this.sec + ' seconds ago';
        }
        if (this.seconds > -900) {
          return this.min + ' minutes ' + this.sec + ' seconds ago';
        }

        return '';
      }

      if (this.day > 123) {
        return Math.trunc(this.day / 30.5) + ' about months';
      }

      if (this.day > 60) {
        return Math.trunc(this.day / 7) + ' about weeks';
      }
      if (this.day === 1) {
        day = '1 day ';
      }
      if (this.day > 1) {
        day = this.day + 'days ';
      }
      if (day === '' && this.hour === 0) {
        return this.displayMin + 'm ' + this.displaySec + 's';
      }
      return day + this.hour + 'h ' + this.displayMin + 'm ' + this.displaySec + 's';
    },

    day() {
      return Math.trunc((Math.abs(this.countdown - this.now)) / 1000 / 86400);
      //return d > 0 ? d + 'days' : '';
    },
    hour() {
      return Math.trunc((Math.abs(this.countdown - this.now)) / 1000 / 3600) % 24;
      //return h > 9 ? h : '0' + h;
    },
    min() {
      return Math.trunc((Math.abs(this.countdown - this.now)) / 1000 / 60) % 60;
      //return m > 9 ? m : '0' + m;
    },
    displayMin() {
      return this.min > 9 ? this.min : '0' + this.min;
    },
    sec() {
      return Math.trunc((Math.abs(this.countdown - this.now)) / 1000) % 60
      //return s > 9 ? s : '0' + s;
    },
    displaySec() {
      return this.sec > 9 ? this.sec : '0' + this.sec;
    },
    seconds() {
      return Math.trunc((this.countdown - this.now) / 1000);
    },
    classObject() {
      const pre = 'inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wide uppercase ';
      if (this.meetup_status === 30) {
        return pre + 'bg-red-100 text-red-600';
      }
      if (this.meetup_status === 15) { // soon
        return pre + 'bg-yellow-100 text-yellow-600';
      }

      if (this.meetup_status === 10) { //wait started
        return pre + 'bg-indigo-100 text-indigo-600';
      }

      if (this.meetup_status) {  // in progress
        return pre + 'bg-green-100 text-green-600';
      }
      return pre + 'bg-red-100 text-red-600';
    },
    url() {
      return (this.meetup_status === IMMINENT || this.meetup_status === IN_PROGRESS) ? this.link : '';
    },
    description() {

      if (this.meetup_status === -1) {
        return 'Waiting...';
      }

      if (this.countdown === '') {
        return 'Unscheduled';
      }

      if (this.meetup_status === UNSCHEDULED) {
        return 'Unscheduled';
      }

      if (this.meetup_status === FINISHED) {
        return 'Finished';
      }
      if (this.meetup_status === YET_TO_START) {
        return 'Opens in ' + this.human;
      }

      const enter = this.link ? ' Click to enter.' : '';

      if (this.meetup_status === IMMINENT) {
        return 'Starting in ' + this.human + '.' + enter;
      }

      if (this.meetup_status === IN_PROGRESS) {
        return 'Started ' + this.human + '.' + enter;
      }

      return 'Error';
    },
    classes() {
      if (this.meetup_status === 30) {
        return 'tag is-default';
      }

      if (this.meetup_status === 15) {
        return 'tag is-warning';
      }

      if (this.meetup_status === 10) {
        return 'tag is-default';
      }

      if (this.meetup_status) {
        return 'tag is-success';
      }
      return 'tag is-danger';
    },
    future_start() {
      return Math.trunc((this.starts_at - this.now) / 1000);
    },
    future_end() {
      return Math.trunc((this.ends_at - this.now) / 1000);
    },
    meetup_status() {

      if (!this.starts_at || !this.ends_at) {
        return UNSCHEDULED;
      }

      if (this.future_start > 0) {
        if (this.future_start < 900) {
          return IMMINENT;
        }
        return YET_TO_START;
      }

      if (this.future_end > 0) {
        return IN_PROGRESS;
      }

      return FINISHED;

    }

  },
  props:
      {
        meetup: {
          type: Object,
          required: true
        },
        link: {
          type: String,
          required: true,
        },
        countdown: {
          type: String,
          required: false,
        },

      },
  setup(props) {
    const starts_at = props.meetup.starts_at ? new Date(props.meetup.starts_at) : '';
    const countdown = starts_at;
    const ends_at = props.meetup.ends_at ? new Date(props.meetup.ends_at) : '';

    return {
      countdown,
      starts_at,
      ends_at,
      //now,
    }
  },
  data() {
    return {
      countdownTimer: null,
      now: new Date(),
    }
  },

  methods: {

    cancelAutoUpdate() {
      clearInterval(this.timer)
    }

  },
  watch: {
    now: {
      immediate: true,
      handler(val) {
        //console.log('here');
        this.countdownTimer = setTimeout(() => {
          this.now = new Date();
        }, 1000);
        //console.log(this.countdownTimer);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  beforeCreate() {

  },
  created() {

    this.timer = setInterval(this.fetchEventsList, 55000);
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  unmounted() {

  }


};
</script>

<style scoped>

</style>